import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { EinMalEinsComponent } from './ein-mal-eins/ein-mal-eins.component';
import { EinsPlusEinsComponent } from './eins-plus-eins/eins-plus-eins.component';
import { EinsDurchEinsComponent } from './eins-durch-eins/eins-durch-eins.component';

@NgModule({
  declarations: [
    AppComponent,
    EinMalEinsComponent,
    EinsPlusEinsComponent,
    EinsDurchEinsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts